// src/components/FavoriteList.jsx
import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Divider } from '@mui/material';
import { fetchNews, fetchSavedNewsIds } from '../lib/api';
import NewsCard from './NewsCard';

const FavoriteList = () => {
  const [savedIds, setSavedIds] = useState([]);
  const [savedArticles, setSavedArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const limit = 100;

  useEffect(() => {
    loadFavorites();
  }, []);

  const loadFavorites = async () => {
    try {
      const ids = await fetchSavedNewsIds();
      setSavedIds(ids);

      if (ids.length === 0) {
        setSavedArticles([]);
        return;
      }

      const fetched = await fetchNews(0, limit); // 🔹 全記事取得
      const filtered = fetched.filter((a) => ids.includes(a.id));
      setSavedArticles(filtered);
    } catch (err) {
      console.error("お気に入りニュースの取得に失敗:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="body1">お気に入り記事を読み込み中...</Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        お気に入り記事一覧
      </Typography>

      {savedArticles.length === 0 ? (
        <Typography variant="body2">お気に入り記事はありません。</Typography>
      ) : (
        savedArticles.map((article, index) => (
          <Box key={article.id}>
            <NewsCard
              article={article}
              isSaved={true}
              onSaveArticle={() => {}} // 削除UIが不要なら空関数
              selectedSite={null}
              onFilterBySite={() => {}}
            />
            {index !== savedArticles.length - 1 && <Divider sx={{ my: 2 }} />}
          </Box>
        ))
      )}
    </Container>
  );
};

export default FavoriteList;
